import { convertFundingFiat } from './fx.js';
import { providerAllowanceUnits } from './provider-allowance.js';
/** Returns null when denomination is unknown; callers must not equate missing data with allowance. */
export function localizeFundingAllowance(period, value, currency, decimals, fx) {
    const sourceCurrency = value.limit.asset.code;
    if (sourceCurrency !== value.remaining.asset.code)
        return null;
    const sourceDecimals = sourceCurrency === currency
        ? decimals
        : /^[A-Z]{3}$/.test(sourceCurrency) && fx?.ratesD9[sourceCurrency]
            ? new Intl.NumberFormat('en', {
                style: 'currency',
                currency: sourceCurrency,
            }).resolvedOptions().maximumFractionDigits
            : value.limit.asset.precision;
    if (sourceDecimals === undefined ||
        (value.limit.asset.precision !== undefined && value.limit.asset.precision !== sourceDecimals) ||
        (value.remaining.asset.precision !== undefined &&
            value.remaining.asset.precision !== sourceDecimals))
        return null;
    const { limit, remaining } = providerAllowanceUnits(value.limit.amount, value.remaining.amount, sourceDecimals, 99999999999999999999n);
    const converted = sourceCurrency !== currency;
    if (converted && (!fx?.ratesD9[sourceCurrency] || !fx.ratesD9[currency]))
        return null;
    return {
        period,
        originalCurrency: sourceCurrency,
        originalDecimals: sourceDecimals,
        originalLimitUnits: limit.toString(),
        originalRemainingUnits: remaining.toString(),
        converted,
        limitUnits: converted && fx
            ? convertFundingFiat(limit.toString(), sourceCurrency, sourceDecimals, currency, decimals, fx, 'down')
            : limit.toString(),
        remainingUnits: converted && fx
            ? convertFundingFiat(remaining.toString(), sourceCurrency, sourceDecimals, currency, decimals, fx, 'down')
            : remaining.toString(),
    };
}
/** Compare in the provider's original denomination, rounding the required payment upward. */
export function fundingAllowanceExceeded(allowance, sourceUnits, currency, decimals, fx) {
    if (!allowance.converted)
        return BigInt(sourceUnits) > BigInt(allowance.originalRemainingUnits);
    if (!fx)
        return true;
    const required = convertFundingFiat(sourceUnits, currency, decimals, allowance.originalCurrency, allowance.originalDecimals, fx, 'up');
    return BigInt(required) > BigInt(allowance.originalRemainingUnits);
}
